import { render, staticRenderFns } from "./smartcontract.vue?vue&type=template&id=32a837b8"
import script from "./smartcontract.vue?vue&type=script&lang=js"
export * from "./smartcontract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports